// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createSelector, Selector } from 'reselect';
import { LabInformation } from '../../../types/Model';
import { ChallengeInformationState } from '../../reducers/challengeInformationReducer';

import { RootState } from '../../rootReducer';

export const ChallengesRaw = (state: RootState):ChallengeInformationState => state.challengeInformationReducer;

export const makeChallengeByIdSelector = (id: number): Selector<RootState, LabInformation> =>
  createSelector(
    ChallengesRaw,
    (challengeInformationReducer) => challengeInformationReducer.challengeInformation[id] || {} as LabInformation
  );

export const makeIsFetchingChallenge = (): Selector<RootState, boolean> => {
  return createSelector(
    ChallengesRaw,
    (challengeInformationReducer) => challengeInformationReducer.isLoading
  );
};

export const makeError = (): Selector<RootState, Error | undefined> => {
  return createSelector(
    ChallengesRaw,
    (challengeInformationReducer) => challengeInformationReducer.error
  );
}
